// Autogenerated file
export const shippingOrderUnmatchingReasonsEnum = {
    MissingAddressPointPlanEnterDateOffset: "MissingAddressPointPlanEnterDateOffset",
    CounterpartyCreationFailed: "CounterpartyCreationFailed",
    CounterpartyExternalIdSetFailed: "CounterpartyExternalIdSetFailed",
    AddressPointCounterpartyCreationFailed: "AddressPointCounterpartyCreationFailed",
    AddressPointGeozoneResolveFailed: "AddressPointGeozoneResolveFailed",
    DistributionBidApplyFailed: "DistributionBidApplyFailed",
};
export const shippingOrderUnmatchingReasons = [
    { label: "Отсутствует плановая дата въезда на точку загрузки/выгрузки", value: "MissingAddressPointPlanEnterDateOffset" },
    { label: "Ошибка при создании контрагента", value: "CounterpartyCreationFailed" },
    { label: "Ошибка установки внешнего ID контрагента", value: "CounterpartyExternalIdSetFailed" },
    { label: "Ошибка создания контрагента точки загрузки или выгрузки", value: "AddressPointCounterpartyCreationFailed" },
    { label: "Ошибка определения геозоны точки загрузки или выгрузки", value: "AddressPointGeozoneResolveFailed" },
    { label: "Ошибка при создании заказа", value: "DistributionBidApplyFailed" },
];
